import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title text-4xl font-bold mb-5 line-height-[1.2px] text-[#4a6350]" }
const _hoisted_2 = { class: "text-content mb-4 line-height-[1.6px] text-lg text-[#4a6350]" }

import { computed, ref } from 'vue'

interface Props {
    title: string;
    highlightLastWord: boolean;
    alternate?: boolean;
    customClass?: string | string[];
    compact?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCard',
  props: {
    title: {},
    highlightLastWord: { type: Boolean },
    alternate: { type: Boolean },
    customClass: {},
    compact: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const titleWords = ref<string[]>(props.title.split(' '));
const lastWord = titleWords.value.pop();
const newTitleWords = ref<string>(titleWords.value.join(' ')) 

const cardStyle = computed(() => {
    if (props.compact) {
        return {
            display: 'inline-block',
            width: 'fit-content',
            maxWidth: 'none',
            minWidth: '0',
            padding: 'clamp(0.75rem, 1vw, 1rem)',
        };
    }

    return {
        width: 'min(1200px, calc(100vw - 2rem))',
        maxWidth: '1200px',
        margin: '2.5rem auto',
        padding: 'clamp(0.75rem, 1vw, 1rem)',
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card relative min-h-[400px] w-auto h-auto bg-[#edf7ed] overflow-hidden text-center rounded-4xl border-2 border-[#b0cfc2]", [props.customClass, { 'alternate-card': props.alternate, 'card-compact': props.compact }]]),
    style: _normalizeStyle(cardStyle.value)
  }, [
    _createElementVNode("h1", _hoisted_1, [
      _createTextVNode(_toDisplayString(newTitleWords.value) + " ", 1),
      _createElementVNode("span", {
        class: _normalizeClass({ 'last-word': _ctx.highlightLastWord })
      }, _toDisplayString(_unref(lastWord)), 3)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "text")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 6))
}
}

})